import React from 'react';

interface ToastProps {
  show: boolean;
  message: string;
}

const Toast: React.FC<ToastProps> = ({ 
  show, 
  message
}) => {
  if (!show) return null;

  return (
    <div className="absolute top-20 left-0 w-full z-[9999] pointer-events-none flex justify-center px-4">
      <div className="bg-yellow-500 text-black px-6 py-3 rounded-lg shadow-lg flex items-center gap-2 animate-fade-in pointer-events-auto max-w-full">
        <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <span className="font-medium break-words text-center">{message}</span>
      </div>
    </div>
  );
};

export default Toast;
